import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BidCreationDocumentModel,
  BidCreationDocumentsModel,
} from "../../models/BidCreationDocumentsModel";

const initialDocumentsState: BidCreationDocumentsModel = {
  documents: [],
};
const BidCreationDocumentsSlice = createSlice({
  name: "Documents",
  initialState: initialDocumentsState,
  reducers: {
    setDocument: (state, action: PayloadAction<BidCreationDocumentModel>) => {
      state.documents.push(action.payload);
    },

    removeDocument: (state, action: PayloadAction<string>) => {
      state.documents = state.documents.filter(
        (file) => file.id !== action.payload
      );
    },

    resetDocuments: (state) => {
      state.documents = initialDocumentsState.documents;
    },
  },
});
export default BidCreationDocumentsSlice;
